// extracted by mini-css-extract-plugin
export default {"decisions":"DecisionList_decisions__bu21y"};